// extracted by mini-css-extract-plugin
export default {"modalAlert":"styles_modalAlert__BIyAp","closeBtn":"styles_closeBtn__uRI1P","accountIsBlockedText":"styles_accountIsBlockedText__iZgj4"};